import { createContext, useContext } from 'react';
import { WeavableAuthContext as WeavableAuthContextType } from '../types';

/**
 * Context for auth - will be created in WeavableProvider
 */
export const WeavableAuthContext = createContext<WeavableAuthContextType | null>(null);

/**
 * Hook to access Weavable auth context
 */
export function useWeavableAuth(): WeavableAuthContextType {
    const context = useContext(WeavableAuthContext);
    if (!context) {
        throw new Error('useWeavableAuth must be used within WeavableProvider');
    }
    return context;
}
